import Jquery from 'jquery'
import MainUtil from '../config/main-config'


var util = {
    dataURLtoFile(dataurl, filename) {//将base64转换为文件
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },

    /**
     * 文件上传
     * @param base64
     * @param fileName
     * @param callback
     */
    uploadImagesByBase64 (base64,fileName,callback){
        if (!fileName || !fileName.trim().length)
            fileName="default.png";

        if (!base64)
            return {code:1,message:"图片数据不能为空",result:null};
        let file = this.dataURLtoFile(base64,fileName);
        let formData = new FormData();
        formData.append('file', file);
        Jquery.ajax({
            url: MainUtil.UPLOAD_API_URL,
            type: "post",
            data: formData,
            contentType: false,
            processData: false,
            dataType:"json",
            mimeType: "multipart/form-data",
            success: function (res) {
                callback && callback(res);
            }
        });
    },


    dateFormat(timestamp, format){
        var that = new Date(timestamp);
        // 不是时间
        if (!that.getTime()) {
            return timestamp;
        }
        var date = {
            "M+": that.getMonth() + 1,
            "d+": that.getDate(),
            "h+": that.getHours(),
            "m+": that.getMinutes(),
            "s+": that.getSeconds(),
            "q+": Math.floor((that.getMonth() + 3) / 3),
            "S+": that.getMilliseconds()
        };
        if (/(y+)/i.test(format)) {
            format = format.replace(RegExp.$1, (that.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        for (var k in date) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1
                    ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
            }
        }
        return format;
    }
};


export default util;
